import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController, AlertController, LoadingController, Platform } from "@ionic/angular/lazy";
import { StorageService } from "../../services/storage.service";
import { ObserverService } from "../../services/observer.service";
import { StripeTerminalReaderService } from "../../services/stripe-terminal-reader.service";
import { Network } from "@capacitor/network";
import { APIService } from "src/app/services/api.service";
import { SmartpayReaderService } from "src/app/services/smartpay-reader.service";

@Component({
    selector: 'app-settings-change-smartpay-reader',
    templateUrl: './settings-change-smartpay-reader.page.html',
    styleUrls: ["./settings-change-smartpay-reader.page.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettingsChangeSmartpayReaderPage implements OnInit {

    selected_reader = null;
    online = false;
    pairing_code = "";
    pairing = false;

	constructor(
		public modalController: ModalController,
		public alertController: AlertController,
		public loadingController: LoadingController,
		private storageService: StorageService,
		private observerService: ObserverService,
		public readerService: StripeTerminalReaderService,
		public apiService: APIService,
		private platform: Platform,
        private smartpayReaderService: SmartpayReaderService
	) {}

	async ngOnInit() {

		this.platform.ready().then(async () => {
			let network_status = await Network.getStatus();
			if (network_status.connected) {
				this.online = true;
			}
            this.observerService.subscribe('network_status_changed', (network_status) => {
                if (network_status.connected) {
                    this.online = true;
                }   
                else {
                    this.online = false;
                }
            });
		});

		this.storageService.get("smartpay_reader").then(reader => {
            if(reader){
                this.selected_reader = reader;        
            }
        });

	}

    pairReader() {
        // NOTE: ignore repeat presses while pairing, otherwise a double tap/Enter pairs twice and alerts "Invalid pairing code"
        if (!this.pairing_code || this.pairing) {
            return;
        }
        this.pairing = true;
        this.smartpayReaderService.pairReader(this.pairing_code).then(() => {
            this.modalController.dismiss("connected");
        }).catch((error) => {
            this.pairing = false;
            if(error == 'invalid_pairing_code') {
                this.presentAlert("Invalid pairing code", "Please make sure you entered the code correctly");
            } else {
                this.presentAlert("Unavailable", "Couldn't connect to reader");
            }
        });
    }

    forgetReader(){
        this.smartpayReaderService.forgetReader();
        this.modalController.dismiss("not_connected");
    }

	capitalise(x: string) {
		return x[0].toUpperCase() + x.substring(1);
	}

	close(): void {
		this.modalController.dismiss(this.selected_reader ? "connected" : "not_connected");
	}

	async presentAlert(header, message) {
		const alert = await this.alertController.create({
			header: header,
			message: message,
			buttons: ["OK"],
		});
		await alert.present();
	}
}
